import type { Lesson } from '../schema.js';

export const BACKGAMMON_LESSONS: Lesson[] = [
  {
    id: 'bg-hitting',
    slug: 'backgammon-hitting-blots',
    title: 'Hitting blots',
    audienceLevel: 'beginner',
    concepts: ['backgammon'],
    steps: [
      {
        kind: 'explain',
        title: 'What is a blot?',
        body: 'A blot is a point with just ONE checker on it. It is all alone — and lonely checkers can be hit! If you land on an enemy blot with one of your moves, their checker is knocked off the board onto the bar and has to start its journey all over again. Two or more checkers on a point make it safe: nobody can land there.',
        narration: 'A blot is a lone checker. Land on it and it goes way back to the bar!',
      },
      {
        kind: 'quiz',
        title: 'Blots and safety',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'How many checkers make a point safe from being hit?',
            choices: ['One', 'Two or more', 'Five or more'],
            correct: 1,
          },
          {
            prompt: 'Where does a hit checker go?',
            choices: [
              'It is removed from the game',
              'It moves to the bar and must start over',
              'It stays where it is',
            ],
            correct: 1,
          },
        ],
      },
    ],
  },
  {
    id: 'bg-bar',
    slug: 'backgammon-the-bar',
    title: 'The bar — stuck at the door',
    audienceLevel: 'beginner',
    concepts: ['backgammon'],
    steps: [
      {
        kind: 'explain',
        title: 'Checkers wait on the bar',
        body: "The bar is the ridge down the middle of the board. Hit checkers wait there until they can come back in — and they must come back in on the far quarter of the board, inside your opponent's home board. While any of your checkers sit on the bar, you may not move anything else. If your entry points are all blocked by the enemy, your whole turn is lost!",
        narration:
          'Bar checkers come back on the far side — and nothing else can move until they do.',
      },
      {
        kind: 'quiz',
        title: 'Bar rules',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'You have a checker on the bar. What are you allowed to move?',
            choices: [
              'Anything — the bar checker waits its turn',
              'Nothing until the bar checker comes back in',
              'Only checkers in your home board',
            ],
            correct: 1,
          },
          {
            prompt: 'Where does your bar checker come back in?',
            choices: [
              'Right where it was hit',
              "In your opponent's home board, on the far side",
              'Anywhere you like',
            ],
            correct: 1,
          },
        ],
      },
    ],
  },
  {
    id: 'bg-bearing-off',
    slug: 'backgammon-bearing-off',
    title: 'Bearing off — the final race',
    audienceLevel: 'beginner',
    concepts: ['backgammon'],
    steps: [
      {
        kind: 'explain',
        title: 'Walk all 15 checkers home',
        body: 'Your home board is the last quarter your checkers travel through. Once ALL fifteen of your checkers are inside it, you can start bearing off — taking them off the board for good. The first player to bear off all fifteen checkers wins! And if your opponent has not borne off even one checker when you win, that is a gammon — an extra-sweet victory.',
        narration: 'Get all fifteen home, then bear them off. First one done wins!',
      },
      {
        kind: 'quiz',
        title: 'Bearing off',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'When may you start bearing off?',
            choices: [
              'Whenever you want',
              'When you are ahead in the race',
              'When all fifteen of your checkers are in your home board',
            ],
            correct: 2,
          },
          {
            prompt: 'Who wins the game?',
            choices: [
              'The first player to bear off all fifteen checkers',
              'The player with a checker on the bar',
              'The player who rolled the most doubles',
            ],
            correct: 0,
          },
        ],
      },
    ],
  },
];
